/**
 * SA-31: classification for the Workshop's starter-block install offer.
 *
 * Pure. A starter block "conflicts" when the draft bundle already holds
 * a block of the same category — the offer dialog then defaults it to
 * unchecked (keep-mine, the SA-84 R3 convention). Order is the
 * template's declared order; the composer re-sorts by category priority
 * at render time, so declaration order only breaks same-priority ties.
 */
import type { PersonaStarterBlock } from '@/hooks/useWorkflows'
import type { PersonaBundleBlock } from '@/types/personaWizard'

export interface ClassifiedStarterBlock {
  block: PersonaStarterBlock
  hasCategoryConflict: boolean
}

export function classifyStarterBlocks(
  draftBlocks: readonly PersonaBundleBlock[],
  starterBlocks: readonly PersonaStarterBlock[],
): ClassifiedStarterBlock[] {
  const draftCategories = new Set(draftBlocks.map((b) => b.category))
  return starterBlocks.map((block) => ({
    block,
    hasCategoryConflict: draftCategories.has(block.category),
  }))
}
